import React, { useState } from 'react';

import Modal from '../../common/Modal';
import Button from '../../common/FormFields/Button';
import { useTranslation } from 'react-i18next';

const TimeslotsConflictModal = (props) => {
  const {
    isModalOpen, handleSubmit, handleClose, resourceIndex, conflictObject
  } = props;
  const { t } = useTranslation();

  const [isErrorDetailsVisible, setIsErrorDetailsVisible] = useState(false);

  const toggleErrorDetails = () => {
    setIsErrorDetailsVisible(prev => !prev)
  }

  return (
    <>
      <Modal isModalOpen={ isModalOpen } handleModalClose={ handleClose } { ...props }>
        <div className="modal-header">
          <h2 className="modal-title">{t('configuration.settings.conflictModal.header')}</h2>
          <button className="modal-close" onClick={ handleClose }>
            <span className="icon-close" />
          </button>
        </div>
        <div className="modal-body modal-content">
          <div className="modal-msg">
            {t('configuration.settings.conflictModal.body', {resourceIndex})}
            <button onClick={toggleErrorDetails} className='show-details'>
              {isErrorDetailsVisible ? 'Hide details' : 'Show more details...'}
            </button>
            {isErrorDetailsVisible && (
            <div className='conflict-details'>
              <h4>Conflict Details</h4>
              <table border={1} cellPadding={8}>
                <thead>
                  <tr>
                    <th>Conflicting Timeslot ID</th>
                    <th>Conflict Time Range</th>
                  </tr>
                </thead>
                <tbody>
                  {conflictObject.conflictingTimeslotIds.map((id, index) => (
                    <tr key={id}>
                      <td>{id}</td>
                      <td>{new Date(conflictObject.conflictDateTimes[index]).toLocaleString()}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>)}
          </div>
        </div>
        <div className="modal-footer light">
          <div className="inputs-group">
            <div className="inputs-group-item">
              <Button type="button" text={t('configuration.settings.change')} onClick={ handleClose } />
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default TimeslotsConflictModal;
